// extracted by mini-css-extract-plugin
export default {"sidebar":"CallingLineNavbar_sidebar__pNBVD","navbar":"CallingLineNavbar_navbar__YKAhz"};